import { Pipe, PipeTransform } from '@angular/core';

const ZEROS_IN_THOUSAND = 3;
const DECIMAL_BASE = 10;

@Pipe({
	name: 'compactNumber',
	standalone: true,
})
export class CompactNumberPipe implements PipeTransform {
	transform(value: number, fractionDigits = 1): string {
		if (Math.abs(value) < 1) {
			return value.toString();
		}

		const suffixes = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

		const thousandPower = Math.floor(Math.log10(Math.abs(value)) / ZEROS_IN_THOUSAND);
		const index = Math.min(thousandPower, suffixes.length - 1);
		const compact = value / Math.pow(DECIMAL_BASE, index * ZEROS_IN_THOUSAND);
		const rounded =
			Math.round(compact * Math.pow(DECIMAL_BASE, fractionDigits)) / Math.pow(DECIMAL_BASE, fractionDigits);

		return rounded + suffixes[index];
	}
}
